import React from 'react';
import AIChatMessage from "../../../../../core/model2/ai/chat-message/chat-message";
import {AIChatProvider} from "../../../../../core/model2/ai/@const";

type Props = {
    message               : AIChatMessage

}



export default function MessageDebugTokens(props: Props) {



    return (
        <>
            <div className="m-b-10">

                <span className="ui5-txt-default bold m-r-10">
                    Total tokens: {props.message.tokens?.totalTokens}
                </span>
                <span className="ui5-txt-default bold m-r-10">
                    Input tokens: {props.message.tokens?.inputTokens}
                </span>
                <span className="ui5-txt-default bold m-r-10">
                    Input cached tokens: {props.message.tokens?.cachedTokens}
                </span>
                <span className="ui5-txt-default bold m-r-10">
                    Output tokens: {props.message.tokens?.outputTokens}
                </span>

                <span className="ui5-txt-default bold">
                    Cost: {Math.round(props.message.cost * 10000) / 10000}
                </span>

            </div>
        </>
    );
}
